module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP1.w.0.0.0"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PT2"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PT2.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PT2.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PT2.w.1.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PT3"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PT3.w.0.0.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page full_page_image",
    attrs: {
      "id": "ORIG-GBS.PP1"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "GBS.PT4"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PT4.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PT4.w.1.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PT4.w.1.1.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PT4.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PT4.w.2.0.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PT4.w.2.0.0.2"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PT5"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PT5.w.0.0.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page full_page_skipped",
    attrs: {
      "id": "ORIG-GBS.PT1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PT2"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    staticStyle: {
      "float": "none"
    },
    attrs: {
      "id": "block.2.0.0.box.0.0.2509.1965.q.101"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PT5.w.1.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0002.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PT5.w.1.0.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.2.1.0.box.508.1955.1534.784.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PT2.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "135%",
      "text-align": "center",
      "margin-left": "0",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.2.1.0.box.508.1955.1534.784.q.80"
    }
  }, [_vm._v("There Was an OLD LADY Who Swallowed Some BUGS")])])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PT3"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    staticStyle: {
      "float": "none"
    },
    attrs: {
      "id": "block.3.0.0.box.0.0.2553.3304.q.101"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PT5.w.2.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0003.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PT5.w.2.0.0.1"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PT4"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.4.0.0.box.251.166.2045.1044.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PT4.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "153%",
      "text-align": "center",
      "margin-left": "0",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.4.0.0.box.251.166.2045.1044.q.80"
    }
  }, [_vm._v("There Was an OLD LADY Who Swallowed Some BUGS")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.4.1.0.box.870.1483.819.202.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PT4.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "106%",
      "text-align": "center",
      "margin-left": "0",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.4.1.0.box.870.1483.819.202.q.80"
    }
  }, [_vm._v("Adapted and Illustrated by johnette Downing")])]), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    staticStyle: {
      "float": "none"
    },
    attrs: {
      "id": "block.4.2.0.box.1198.2857.180.150.q.101"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PT5.w.3.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0004.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PT5.w.3.0.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.4.3.0.box.781.3025.997.130.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PT4.w.3.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "center",
      "color": "rgb(0, 0, 0)",
      "clear": "both"
    },
    attrs: {
      "id": "para.4.3.0.box.781.3025.997.58.q.90"
    }
  }, [_vm._v("PELICAN PUBLISHING COMPANY")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PT4.w.3.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "center",
      "font-variant": "small-caps",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.4.3.1.box.1110.3096.340.59.q.80"
    }
  }, [_vm._v("Gretna 2010")])])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PT5"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.5.0.0.box.1104.141.224.51.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PT5.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-align": "center",
      "font-style": "italic",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.5.0.0.box.1104.141.224.51.q.80"
    }
  }, [_vm._v("For Dianne")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.5.1.0.box.155.254.431.155.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PT5.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-left": "0",
      "margin-bottom": "0",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.5.1.0.box.155.254.376.46.q.90"
    }
  }, [_vm._v("Copyright © 2010")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PT5.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-left": "0",
      "margin-bottom": "0",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.5.1.1.box.155.308.431.46.q.80"
    }
  }, [_vm._v("By Johnette Downing")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PT5.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-left": "0",
      "margin-bottom": "0",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.5.1.2.box.155.362.390.47.q.90"
    }
  }, [_vm._v("All rights reserved")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.5.2.0.box.598.628.1236.160.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PT5.w.2.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "0",
      "text-align": "center",
      "font-style": "italic",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.5.2.0.box.598.628.1236.160.q.60"
    }
  }, [_vm._v("The word “Pelican” and the depiction of a pelican are trademarks of Pelican Publishing Company, Inc., and are registered in the U.S. Patent and Trademark Office.")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.5.3.0.box.155.1121.466.46.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PT5.w.3.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "0",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.5.3.0.box.155.1121.466.46.q.50"
    }
  }, [_vm._v("ISBN 9781589808584")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.5.4.0.box.95.2781.165.123.q.101"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PT5.w.4.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "0",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.5.4.0.box.95.2781.165.123.q.101"
    }
  }, [_vm._v("♾")])]), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    staticStyle: {
      "float": "none"
    },
    attrs: {
      "id": "block.5.5.0.box.251.2750.177.161.q.101"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PT5.w.4.0.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0005.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PT5.w.4.0.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.5.6.0.box.155.2908.1022.157.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PT5.w.6.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-left": "0",
      "margin-bottom": "0",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.5.6.0.box.155.2908.423.46.q.80"
    }
  }, [_vm._v("Printed in Singapore")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PT5.w.6.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "0",
      "color": "rgb(0, 0, 0)"
    },
    attrs: {
      "id": "para.5.6.1.box.155.2962.952.49.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PT5.w.4.1.0"
    }
  }), _vm._v("Published by Pelican Publishing Company, Inc.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PT5.w.6.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.5.6.2.box.155.3016.1022.49.q.70"
    }
  }, [_vm._v("1000 Burmaster Street, Gretna, Louisiana 70053")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PT6"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PT6.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PT6.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PT6.w.1.0.0.1"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-96af5232","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/content0006.vue
// module id = 54
// module chunks = 0